import React from 'react';
import {apiRoutePrefix, RouteComponent} from '../../../RouteComponent';
import {Box, Divider} from '@material-ui/core';
import ObjectHeader from '../ObjectHeader';
import {jsonObject, workOrderAttributes, workOrdersHeader} from '../../data/workOrders/workOrder';
import RequestDefinition from '../RequestDefinition';
import ObjectDefinition from '../ObjectDefinition';

export default new RouteComponent(`${apiRoutePrefix}/work-orders`, () => {
    return (
        <div>
            <ObjectHeader data={ workOrdersHeader }/>

            <Box mb={ 3 }>
                <Divider/>
            </Box>

            <ObjectDefinition data={ {
                title: 'The work order object',
                attributes: workOrderAttributes,
                jsonObject: jsonObject
            } }/>

            {
                workOrdersHeader.endpoints.map(data => (
                    <>
                        <Box mb={3}>
                            <Divider/>
                        </Box>
                        <RequestDefinition {...data} />
                    </>
                ))
            }
        </div>
    );
});